{
  "version": 1,
  "asset_id": "c6319747-9638-4738-8420-0b68ae02e76e",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/c6319747-9638-4738-8420-0b68ae02e76e/plumbing-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/c6319747-9638-4738-8420-0b68ae02e76e/plumbing-card.webp",
  "original_filename": "plumbing-card.webp",
  "size": 6670,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:19Z"
}
